import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { PortfolioHeader } from "@/components/portfolio/PortfolioHeader";
import { PROFILE } from "@/components/portfolio/profileData";
import { renderSections } from "@/components/sections";
import { usePageSections } from "@/hooks/usePageSections";
import { PORTFOLIO_BUILTINS as BUILTINS } from "@/lib/builtinSections";

export default function PortfolioPage() {
  const [lang, setLang] = useState(() => localStorage.getItem("portfolio-lang") || "es");
  const sections = usePageSections("portfolio", Object.keys(BUILTINS));

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    localStorage.setItem("portfolio-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <div className="min-h-screen bg-[#081B33] text-white" data-testid="portfolio-page">
      <PortfolioHeader lang={lang} setLang={setLang} />
      <main className="tech-grid">
        <div className="mx-auto max-w-6xl px-5 pb-16">
          {sections ? (
            renderSections(sections, BUILTINS, { lang })
          ) : (
            <div className="flex min-h-[60vh] items-center justify-center" data-testid="portfolio-loading">
              <Loader2 className="h-6 w-6 animate-spin text-[#FF5500]" />
            </div>
          )}
        </div>
      </main>
      <footer className="border-t border-white/10 py-8 text-center font-mono text-xs text-slate-500" data-testid="portfolio-footer">
        © {new Date().getFullYear()} {PROFILE.name} ·{" "}
        <a href={`mailto:${PROFILE.email}`} className="text-[#FF7A33] hover:underline" data-testid="portfolio-email-link">
          {PROFILE.email}
        </a>
      </footer>
    </div>
  );
}
